import React, { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const PageShell = ({ title, subtitle, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FBFBF9]">
      <Navbar />
      <main className="mx-auto max-w-3xl px-6 pb-24 pt-36 md:px-12 md:pt-44">
        <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
          SisterSafe
        </p>
        <h1 className="font-heading mt-4 text-4xl font-semibold tracking-tight text-[#111E16] md:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-lg leading-relaxed text-[#4A5F52]">{subtitle}</p>
        )}
        <div className="mt-12 space-y-8">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-heading text-xl font-semibold text-[#111E16]">{heading}</h2>
    <div className="mt-3 space-y-3 leading-relaxed text-[#4A5F52]">{children}</div>
  </section>
);
